import { render, staticRenderFns } from "./FunctinalityDetailsListMob.vue?vue&type=template&id=6e153b91&scoped=true&"
import script from "./FunctinalityDetailsListMob.vue?vue&type=script&lang=js&"
export * from "./FunctinalityDetailsListMob.vue?vue&type=script&lang=js&"
import style0 from "./FunctinalityDetailsListMob.vue?vue&type=style&index=0&id=6e153b91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e153b91",
  null
  
)

export default component.exports